(() => {
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];
  const body = document.body;

  // Keep fixed/sticky UI aligned with the real header height on every page.
  const syncLayoutOffsets = () => {
    const header = qs('[data-site-header]');
    const nav = qs('.atelier-nav', header);
    const mobileBar = qs('.atelier-mobilebar');
    if (mobileBar) body.classList.add('has-mobile-bar'); else body.classList.remove('has-mobile-bar');
    if (header) {
      const headerBottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--sticky-header-offset', `${headerBottom}px`);
    }
    if (nav) {
      const navBottom = Math.max(0, Math.round(nav.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--mega-top', `${navBottom}px`);
    }
  };
  syncLayoutOffsets();
  window.addEventListener('resize', syncLayoutOffsets, { passive: true });
  window.addEventListener('scroll', syncLayoutOffsets, { passive: true });
  const rootRoute = () => window.Shopify?.routes?.root || '/';
  const scrim = qs('[data-drawer-scrim]');
  const toast = qs('[data-toast]');

  const lock = (on) => body.classList.toggle('drawer-open', on);
  const showScrim = (on) => scrim?.classList.toggle('is-visible', on);
  const notify = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(window.__atelierToast);
    window.__atelierToast = setTimeout(() => toast.classList.remove('is-visible'), 2400);
  };

  const closeAllDrawers = () => {
    qsa('[data-search-drawer], [data-mobile-menu], [data-filter-drawer], [data-size-guide-modal], [data-wishlist-drawer], [data-cart-drawer]').forEach(el => {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    lock(false); showScrim(false);
  };

  const openDrawer = (el) => {
    if (!el) return;
    closeAllDrawers();
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lock(true); showScrim(true);
  };

  document.addEventListener('click', (e) => {
    const searchOpen = e.target.closest('[data-search-open]');
    const searchClose = e.target.closest('[data-search-close]');
    const menuOpen = e.target.closest('[data-mobile-menu-open]');
    const menuClose = e.target.closest('[data-mobile-menu-close]');
    const filterOpen = e.target.closest('[data-filter-open]');
    const filterClose = e.target.closest('[data-filter-close]');
    const sizeOpen = e.target.closest('[data-size-guide-open]');
    const sizeClose = e.target.closest('[data-size-guide-close]');
    const utilityClose = e.target.closest('[data-utility-close]');
    const wishlistOpen = e.target.closest('[data-wishlist-open]');
    const cartOpen = e.target.closest('[data-cart-open]');
    if (searchOpen) { openDrawer(qs('[data-search-drawer]')); setTimeout(() => qs('[data-predictive-search-input]')?.focus(), 100); }
    if (searchClose || menuClose || filterClose || sizeClose || utilityClose) closeAllDrawers();
    if (menuOpen) openDrawer(qs('[data-mobile-menu]'));
    if (filterOpen) openDrawer(qs('[data-filter-drawer]'));
    if (sizeOpen) openDrawer(qs('[data-size-guide-modal]'));
    if (wishlistOpen) { openDrawer(qs('[data-wishlist-drawer]')); renderWishlist(); }
    if (cartOpen) { openDrawer(qs('[data-cart-drawer]')); renderCartDrawer(); }
    if (e.target === scrim) closeAllDrawers();
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAllDrawers(); });

  // Predictive search
  const searchInput = qs('[data-predictive-search-input]');
  const resultBox = qs('[data-predictive-results]');
  let searchTimer;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    const term = searchInput.value.trim();
    if (term.length < 2) { if (resultBox) resultBox.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      try {
        const root = rootRoute();
        const url = `${root}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,query,collection&resources[limit]=6&section_id=predictive-search`;
        const res = await fetch(url);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const html = doc.querySelector('#shopify-section-predictive-search')?.innerHTML || text;
        if (resultBox) resultBox.innerHTML = html;
      } catch (_) { /* silent fallback to standard search */ }
    }, 180);
  });

  // Sort collection
  qsa('[data-sort-select]').forEach(select => select.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.assign(url.toString());
  }));

  // Native facets submit on desktop with gentle debounce for checkbox interactions.
  qsa('[data-facets-form]').forEach(form => {
    form.addEventListener('change', (e) => {
      if (window.innerWidth < 990 || e.target.type === 'number') return;
      form.requestSubmit();
    });
  });

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency, maximumFractionDigits: 2 }).format((cents || 0) / 100); }
    catch { return `${currency} ${((cents || 0) / 100).toFixed(2)}`; }
  };

  const renderCartDrawer = async () => {
    const content = qs('[data-cart-content]');
    const footer = qs('[data-cart-footer]');
    if (!content || !footer) return;
    content.innerHTML = '<div class="utility-loading">Loading your bag…</div>';
    footer.innerHTML = '';
    try {
      const cart = await fetch(`${rootRoute()}cart.js`, { headers: { 'Accept': 'application/json' } }).then(r => r.json());
      if (!cart.item_count) {
        content.innerHTML = `<div class="utility-empty"><span>◇</span><h3>Your cart is empty.</h3><p>Browse the store and add something useful.</p><a class="button button--dark button--full" href="${rootRoute()}collections/all">Shop products</a></div>`;
        return;
      }
      content.innerHTML = cart.items.map(item => `<div class="utility-product">
        <a class="utility-product__image" href="${item.url}">${item.image ? `<img src="${item.image}" alt="">` : ''}</a>
        <div class="utility-product__info"><small>${item.vendor || ''}</small><a href="${item.url}" class="utility-product__title">${item.product_title}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<span>${item.variant_title}</span>` : ''}<div><em>Qty ${item.quantity}</em><strong>${money(item.final_line_price)}</strong></div></div>
      </div>`).join('');
      footer.innerHTML = `<div class="utility-total"><span>Subtotal</span><strong>${money(cart.total_price)}</strong></div><p>Shipping and taxes calculated at checkout.</p><a class="button button--primary button--full" href="${rootRoute()}checkout">Secure checkout</a><a class="utility-view-cart" href="${rootRoute()}cart">View shopping bag</a>`;
    } catch { content.innerHTML = '<div class="utility-empty"><h3>Could not load the bag.</h3><p>Please open the shopping bag page to continue.</p><a class="button button--dark button--full" href="${rootRoute()}cart">View bag</a></div>'; }
  };

  const renderWishlist = async () => {
    const content = qs('[data-wishlist-content]');
    if (!content) return;
    const handles = getWishlist();
    if (!handles.length) { content.innerHTML = '<div class="utility-empty"><span>♡</span><h3>Save your favourites here.</h3><p>Save products you like and return to them anytime on this device.</p></div>'; return; }
    content.innerHTML = '<div class="utility-loading">Loading your saved products…</div>';
    try {
      const products = (await Promise.all(handles.slice(0, 20).map(async h => {
        try { const r = await fetch(`${rootRoute()}products/${h}.js`); return r.ok ? await r.json() : null; } catch { return null; }
      }))).filter(Boolean);
      if (!products.length) { content.innerHTML = '<div class="utility-empty"><h3>No saved products found.</h3></div>'; return; }
      content.innerHTML = products.map(product => `<div class="utility-product">
        <a class="utility-product__image" href="${rootRoute()}products/${product.handle}">${product.featured_image ? `<img src="${product.featured_image}" alt="">` : ''}</a>
        <div class="utility-product__info"><small>${product.vendor || ''}</small><a href="${rootRoute()}products/${product.handle}" class="utility-product__title">${product.title}</a><div><em>${money(product.price)}</em><button type="button" class="utility-remove" data-wishlist-button data-product-handle="${product.handle}">Remove</button></div></div>
      </div>`).join('');
    } catch { content.innerHTML = '<div class="utility-empty"><h3>Could not load saved products.</h3></div>'; }
  };

  // AJAX quick add
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-quick-add-form]');
    if (!form) return;
    e.preventDefault();
    const button = form.querySelector('button');
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const res = await fetch(`${rootRoute()}cart/add.js`, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
      if (!res.ok) throw new Error('Could not add item');
      notify('Added to your bag');
      const cart = await fetch(`${rootRoute()}cart.js`).then(r => r.json());
      qsa('.cart-count').forEach(c => { c.textContent = cart.item_count; c.classList.toggle('is-hidden', cart.item_count === 0); });
      openDrawer(qs('[data-cart-drawer]'));
      renderCartDrawer();
    } catch (err) { notify(err.message || 'Could not add item'); }
    finally { if (button) { button.disabled = false; button.textContent = original; } }
  });

  // Product-page add to cart uses the cart drawer when enabled.
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || !qs('[data-cart-drawer]')) return;
    if (e.submitter && e.submitter.name && e.submitter.name !== 'add') return;
    e.preventDefault();
    const button = qs('.product-form__submit', form);
    const label = qs('[data-add-to-cart-text]', form);
    const original = label?.textContent;
    if (button) button.disabled = true;
    if (label) label.textContent = 'Adding…';
    try {
      const res = await fetch(`${rootRoute()}cart/add.js`, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
      if (!res.ok) {
        let message = 'Could not add this item';
        try { const data = await res.json(); message = data.description || data.message || message; } catch (_) {}
        throw new Error(message);
      }
      const cart = await fetch(`${rootRoute()}cart.js`).then(r => r.json());
      qsa('.cart-count').forEach(c => { c.textContent = cart.item_count; c.classList.toggle('is-hidden', cart.item_count === 0); });
      notify('Added to your bag');
      openDrawer(qs('[data-cart-drawer]'));
      renderCartDrawer();
    } catch (err) { notify(err.message || 'Could not add item'); }
    finally { if (button) button.disabled = false; if (label && original) label.textContent = original; }
  });

  // Quantity controls.
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const wrap = e.target.closest('.quantity-control');
    const input = qs('[data-qty-input]', wrap);
    if (!input) return;
    const current = Math.max(1, parseInt(input.value || '1', 10));
    input.value = minus ? Math.max(1, current - 1) : current + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Lightweight wishlist stored locally; can later be swapped for a dedicated app.
  const wishlistKey = 'atelier-wishlist';
  const getWishlist = () => { try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch { return []; } };
  const setWishlist = (items) => localStorage.setItem(wishlistKey, JSON.stringify(items));
  const syncWishlistButtons = () => {
    const items = getWishlist();
    qsa('[data-wishlist-button]').forEach(btn => btn.classList.toggle('is-active', items.includes(btn.dataset.productHandle)));
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-button]');
    if (!btn) return;
    e.preventDefault();
    const handle = btn.dataset.productHandle;
    const items = getWishlist();
    const index = items.indexOf(handle);
    if (index >= 0) { items.splice(index, 1); notify('Removed from wishlist'); } else { items.push(handle); notify('Saved to wishlist'); }
    setWishlist(items); syncWishlistButtons();
  });
  syncWishlistButtons();

  // Product variants
  qsa('[data-product-root]').forEach(root => {
    const variantsEl = qs('[data-product-json]', root);
    const form = qs('[data-product-form]', root);
    if (!variantsEl || !form) return;
    const variants = JSON.parse(variantsEl.textContent);
    const radios = qsa('input[type="radio"][name^="options"]', form);
    const idInput = qs('[data-variant-id]', form);
    const addButton = qs('.product-form__submit', form);
    const addText = qs('[data-add-to-cart-text]', form);
    const updateVariant = () => {
      const selected = qsa('.product-option', form).map(group => qs('input:checked', group)?.value);
      const variant = variants.find(v => v.options.every((opt, i) => opt === selected[i]));
      if (!variant) { if (addButton) addButton.disabled = true; if (addText) addText.textContent = 'Unavailable'; return; }
      if (idInput) idInput.value = variant.id;
      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'Add to bag' : 'Sold out';
      const sku = qs('[data-product-sku]', root);
      if (sku) sku.textContent = variant.sku || '—';
      const inventory = qs('[data-product-inventory]', root);
      if (inventory) {
        inventory.classList.toggle('is-available', Boolean(variant.available));
        const text = inventory.querySelector('span');
        if (text) text.textContent = variant.available ? 'In stock and ready to ship' : 'Currently unavailable';
      }
      const priceWrap = qs('[data-price-wrap]', root);
      if (priceWrap) {
        const current = qs('[data-price-current]', priceWrap);
        const compare = qs('[data-price-compare]', priceWrap);
        const saving = qs('[data-price-saving]', priceWrap);
        if (current) current.textContent = money(variant.price);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compare) { compare.textContent = onSale ? money(variant.compare_at_price) : ''; compare.classList.toggle('is-hidden', !onSale); }
        if (saving) { const pct = onSale ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0; saving.textContent = `${pct}% off`; saving.classList.toggle('is-hidden', !onSale); }
      }
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    };
    radios.forEach(r => r.addEventListener('change', updateVariant));
  });

  // Product recommendations lazy load
  const recommendationSections = qsa('[data-product-recommendations]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(async entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target; observer.unobserve(el);
      try { const html = await fetch(el.dataset.url).then(r => r.text()); const doc = new DOMParser().parseFromString(html, 'text/html'); const replacement = doc.querySelector('[data-product-recommendations]'); if (replacement?.innerHTML.trim()) el.innerHTML = replacement.innerHTML; } catch (_) {}
    }), { rootMargin: '300px' });
    recommendationSections.forEach(el => observer.observe(el));
  }
  // Gentle section reveal. Disabled automatically for reduced motion by CSS.
  if (body.classList.contains('reveal-enabled') && 'IntersectionObserver' in window) {
    const revealSections = qsa('.shopify-section').filter(el => !el.classList.contains('shopify-section-group-header-group') && !el.classList.contains('shopify-section-group-footer-group'));
    revealSections.forEach(el => el.classList.add('atelier-pending'));
    const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.remove('atelier-pending');
      revealObserver.unobserve(entry.target);
    }), { rootMargin: '100px 0px', threshold: 0.04 });
    revealSections.forEach(el => revealObserver.observe(el));
  }

})();
